import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@paypalcorp/pp-react';
import { parseData, preventTabNabbing } from '../../../lib/helpers';

export const feesCard = (feeCardContent = [], handleClickFPTI) => {
  return (
    <div className="details-fees-total-card">
      {feeCardContent.map((fee, idx) => (
        <IncludedCardFee
          key={`details-fee-${idx}`}
          componentContent={fee}
          handleClickFPTI={handleClickFPTI}
        />
      ))}
    </div>
  );
};

export const feesSideSection = (feesSideContent = {}) => {
  const {
    subtitleLink = '[]',
    subtitle,
    title,
    handleClickFPTI
  } = feesSideContent;

  const parsedSubtitleLink = parseData(subtitleLink)[0] || {};

  return (
    <div className="details-fees-side">
      <h2>{title}</h2>
      <p className="font-size-p">{subtitle}</p>
      {parsedSubtitleLink?.url && (
        <Link
          rel={preventTabNabbing(parsedSubtitleLink.url)}
          href={parsedSubtitleLink.url}
          onClick={() =>
            parsedSubtitleLink.fptiLinkName
              ? handleClickFPTI(parsedSubtitleLink.fptiLinkName)
              : {}
          }
        >
          {parsedSubtitleLink.text}
        </Link>
      )}
    </div>
  );
};

const IncludedCardFee = ({ componentContent = {}, handleClickFPTI }) => {
  const {
    title,
    fee,
    feeSubText,
    desc,
    linkText,
    link,
    fptiLinkName
  } = componentContent;

  return (
    <div className="details-fees-card">
      <div className="details-fees-top-card">
        <h3>{title}</h3>
        <h4>{fee}</h4>
        <p
          className="font-size-p"
          dangerouslySetInnerHTML={{ __html: feeSubText }}
        ></p>
      </div>
      {desc && (
        <div className="details-fees-bottom-card">
          <p
            className="pay-description font-size-p"
            dangerouslySetInnerHTML={{ __html: desc }}
          ></p>
          {link && (
            <a
              href={link}
              rel={preventTabNabbing(link)}
              onClick={() => handleClickFPTI(fptiLinkName)}
            >
              {linkText}
            </a>
          )}
        </div>
      )}
    </div>
  );
};

feesCard.propTypes = {
  componentContent: PropTypes.object
};

IncludedCardFee.propTypes = {
  componentContent: PropTypes.object,
  cardTitle: PropTypes.string,
  fee: PropTypes.string,
  feeSubtext: PropTypes.string,
  cardFooterText: PropTypes.string,
  fptiLinkName: PropTypes.string,
  handleClickFPTI: PropTypes.func
};

feesSideSection.propTypes = {
  feeSideTitle: PropTypes.string,
  feeSideSubtitle: PropTypes.string,
  feeSideLinkUrl: PropTypes.string,
  feeSideLinkText: PropTypes.string
};

export default {
  feesCard,
  feesSideSection
};
